import React, { useState, useEffect } from "react";
import Navbar from "./../Navbar/index";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TotalSale from "./TotalSale";
import TimeStats from "./TimeStats";
import TimeSales from "./TimeSales";
import TimelineTable from "./TimelineTableSummary";
import Footer from "../Footer";
import "../../scss/timeline.scss";
import FoodTable from "./FoodTable";
import TopFoodTable from "./Topfoodtable";
import BeverageTable from "./BeverageTable";
import TopBeverageTable from "./Topbeveragetable";
import DateTimeChart from "./DateTimeChart";
import SelectSearchInput from "../SelectSearch";
import { ImSpinner8 } from "react-icons/im";
import { FiAlertCircle } from "react-icons/fi";

const Timeline = () => {
  const url = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  /* ================= STATE ================= */

  const [token, setToken] = useState("");

  const [startDate, setStartDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const [selectedOutlet, setSelectedOutlet] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showTimeline, setShowTimeline] = useState(false);

  const [totalSaleSummary, setTotalSaleSummary] = useState({});
  const [timeStats, setTimeStats] = useState({});
  const [elevenThree, setelevenThree] = useState({});
  const [sixTen, setsixTen] = useState({});
  const [threeSix, setThreeSix] = useState({});
  const [tableSumamry, setTableSumamry] = useState([]);

  const [food113, setFood113] = useState([]);
  const [beverage113, setBeverage113] = useState([]);
  const [foodsum113, setfoodsum113] = useState("");
  const [beveragesum113, setbeveragesum113] = useState("");
  const [totalfoodquantity113, settotalfoodquantity113] = useState(0);
  const [totalbeveragequantity113, settotalbeveragequantity113] = useState(0);

  const [food36, setFood36] = useState([]);
  const [beverage36, setBeverage36] = useState([]);
  const [foodsum36, setfoodsum36] = useState("");
  const [beveragesum36, setbeveragesum36] = useState("");
  const [totalfoodquantity36, settotalfoodquantity36] = useState(0);
  const [totalbeveragequantity36, settotalbeveragequantity36] = useState(0);

  const [food610, setFood610] = useState([]);
  const [beverage610, setBeverage610] = useState([]);
  const [foodsum610, setfoodsum610] = useState("");
  const [beveragesum610, setbeveragesum610] = useState("");
  const [totalfoodquantity610, settotalfoodquantity610] = useState(0);
  const [totalbeveragequantity610, settotalbeveragequantity610] = useState(0);

  const [topfood, setTopFood] = useState([]);
  const [topbeverage, setTopBeverage] = useState([]);
  const [topfoodrev, setTopFoodRev] = useState([]);
  const [topbeveragerev, setTopBeverageRev] = useState([]);

  /* ================= AUTH CHECK ================= */

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (!storedToken) {
      navigate("/");
    } else {
      setToken(storedToken);
    }
  }, [navigate]);

  /* ================= API ================= */

  const viewTimeline = () => {
    if (!selectedOutlet) {
      setError("Please select an outlet");
      return;
    }

    setLoading(true);
    setError("");
    setShowTimeline(false);

    axios
      .post(`${url}/orderhistory`, {
        outlet: selectedOutlet,
        dateStart: startDate,
        dateEnd: endDate,
        token,
      })
      .then((response) => {
        const data = response.data || {};

        setShowTimeline(true);
        setTimeStats(data?.Timestats || {});
        setTotalSaleSummary(data?.TotalSalesSummary || {});
        setelevenThree(data?.Time_sales?.eleven_three || {});
        setsixTen(data?.Time_sales?.six_ten || {});
        setThreeSix(data?.Time_sales?.three_six || {});
        setTableSumamry(data?.table_summary || []);

        setFood113(data?.Time_sales?.eleven_three?.food_sales || []);
        setBeverage113(data?.Time_sales?.eleven_three?.beverage_sales || []);
        setfoodsum113(data?.Time_sales?.eleven_three?.total_food_sales || "");
        setbeveragesum113(data?.Time_sales?.eleven_three?.total_beverage_sales || "");
        settotalfoodquantity113(data?.Time_sales?.eleven_three?.foodsales_count || 0);
        settotalbeveragequantity113(data?.Time_sales?.eleven_three?.beveragesales_count || 0);

        setFood36(data?.Time_sales?.three_six?.food_sales || []);
        setBeverage36(data?.Time_sales?.three_six?.beverage_sales || []);
        setfoodsum36(data?.Time_sales?.three_six?.total_food_sales || "");
        setbeveragesum36(data?.Time_sales?.three_six?.total_beverage_sales || "");
        settotalfoodquantity36(data?.Time_sales?.three_six?.foodsales_count || 0);
        settotalbeveragequantity36(data?.Time_sales?.three_six?.beveragesales_count || 0);

        setFood610(data?.Time_sales?.six_ten?.food_sales || []);
        setBeverage610(data?.Time_sales?.six_ten?.beverage_sales || []);
        setfoodsum610(data?.Time_sales?.six_ten?.total_food_sales || "");
        setbeveragesum610(data?.Time_sales?.six_ten?.total_beverage_sales || "");
        settotalfoodquantity610(data?.Time_sales?.six_ten?.foodsales_count || 0);
        settotalbeveragequantity610(data?.Time_sales?.six_ten?.beveragesales_count || 0);

        setTopFood(data?.Top_tenselling_food_by_qty || []);
        setTopBeverage(data?.Top_tenselling_beverage_by_qty || []);
        setTopFoodRev(data?.Top_tenselling_food_by_revenue || []);
        setTopBeverageRev(data?.Top_tenselling_beverage_by_revenue || []);
      })
      .catch(() => {
        setError("Failed to fetch timeline data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* ================= UI ================= */

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow">
        <div className="py-4 bg-[rgb(238,239,243)] p-1">
          <div className="p-4 rounded bg-white shadow-md max-w-5xl mx-auto mt-2">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <label className="flex items-center gap-2 text-sm font-medium">
                Start Date:
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </label>

              <SelectSearchInput
                token={token}
                setToken={setToken}
                selectedOutlet={selectedOutlet}
                setSelectedOutlet={setSelectedOutlet}
              />

              <label className="flex items-center gap-2 text-sm font-medium">
                End Date:
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </label>
            </div>

            <div className="flex mt-3 justify-center">
              <button
                onClick={viewTimeline}
                disabled={loading}
                className="flex items-center gap-1 px-4 py-2 rounded-sm font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm disabled:opacity-70"
              >
                {loading ? <ImSpinner8 className="animate-spin" /> : "Search"}
              </button>
            </div>
          </div>

          {loading && (
            <div className="flex justify-center py-20">
              <ImSpinner8 className="animate-spin text-4xl" />
            </div>
          )}

          {error && !loading && (
            <div className="flex flex-col items-center py-20 text-red-600">
              <FiAlertCircle className="text-4xl mb-4" />
              <p>{error}</p>
            </div>
          )}

          <div className="bg-timeline">
            {showTimeline && !loading && (
              <div className="timeline">
                <div className="left-timeline">
                  <h4>{selectedOutlet}</h4>
                  <div className="hl-line"></div>
                  <div className="md-flex">
                    <TotalSale totalSaleSummary={totalSaleSummary} />
                    <div className="hl-line"></div>
                    <TimeStats timeStats={timeStats} />
                  </div>
                  <div className="hl-line"></div>
                  <TimeSales
                    elevenThree={elevenThree}
                    sixTen={sixTen}
                    threeSix={threeSix}
                  />
                </div>
                <div className="right-timeline-table">
                  <TimelineTable tableSumamry={tableSumamry} />

                  <div className="py-16">
                    <DateTimeChart tableSummary={tableSumamry} />
                  </div>

                  <div className="time-stamp ml-8 font-bold">
                    <label className="morning">11AM -3PM</label>
                  </div>

                  <div className="food-beverage-table-width">
                    <div className="food-beverage-table">
                      <FoodTable
                        food={food113}
                        foodsum={foodsum113}
                        totalfoodquantity={totalfoodquantity113}
                      />
                      <BeverageTable
                        beverage={beverage113}
                        beveragesum={beveragesum113}
                        totalbeveragequantity={totalbeveragequantity113}
                      />
                    </div>
                  </div>
                  <div className="time-stamp ml-8 font-bold">
                    <label className="evening">3PM -6PM</label>
                  </div>
                  <div className="food-beverage-table-width">
                    <div className="food-beverage-table ">
                      <FoodTable
                        food={food36}
                        foodsum={foodsum36}
                        totalfoodquantity={totalfoodquantity36}
                      />
                      <BeverageTable
                        beverage={beverage36}
                        beveragesum={beveragesum36}
                        totalbeveragequantity={totalbeveragequantity36}
                      />
                    </div>
                  </div>
                  <div className="time-stamp ml-8 font-bold">
                    <label className="late">6PM -10PM</label>
                  </div>
                  <div className="food-beverage-table-width">
                    <div className="food-beverage-table">
                      <FoodTable
                        food={food610}
                        foodsum={foodsum610}
                        totalfoodquantity={totalfoodquantity610}
                      />
                      <BeverageTable
                        beverage={beverage610}
                        beveragesum={beveragesum610}
                        totalbeveragequantity={totalbeveragequantity610}
                      />
                    </div>
                  </div>
                  <div className="time-stamp ml-8 font-bold">
                    <label className="late">Top 10 Selling Items by Quantity</label>
                  </div>
                  <div className="food-beverage-table-width">
                    <div className="food-beverage-table">
                      <TopFoodTable food={topfood} />
                      <TopBeverageTable beverage={topbeverage} />
                    </div>
                  </div>
                  <div className="time-stamp ml-8 font-bold">
                    <label className="late">Top 10 Selling Items by Revenue</label>
                  </div>
                  <div className="food-beverage-table-width">
                    <div className="food-beverage-table">
                      <TopFoodTable food={topfoodrev} />
                      <TopBeverageTable beverage={topbeveragerev} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Timeline;
